export const FBQviewCategory = (products) => {
  if (window.fbq) {
    const sku = products.map((item) => item.sku);

    window.fbq("trackCustom", "ViewCategory", {
      content_ids: sku,
      content_type: "product",
    });
  }
};
